import { useEffect, useState } from 'react';

import useUser from '@montugroup/circuit-shared/hooks/user/useUser';
import type { Card } from '@montugroup/circuit-shared/types/braze';

import useCustomer from '@/hooks/user/useCustomer';
import { changeUser, init, updateUserAttributes } from '@/services/braze.service';

let isInitialized = false;

/**
 * Inits Braze user tracking
 *
 * @returns brazeContentCards
 */
export function useBraze() {
  const [brazeContentCards, setBrazeContentCards] = useState<Card[]>([]);
  const { data: user } = useUser();
  const { data: customer } = useCustomer();

  useEffect(() => {
    if (!isInitialized) {
      init({ contentCardsSubscriber: ({ cards }) => setBrazeContentCards(cards as Card[]) });
      isInitialized = true;
    }
  }, [user]);

  useEffect(() => {
    if (user?.email) {
      changeUser(user.email);
    }
  }, [user?.email]);

  useEffect(() => {
    if (user && customer) {
      updateUserAttributes({ user, customer });
    }
  }, [customer, user]);

  return { brazeContentCards };
}
